<template>
    <div>
        <div class="step-content select-bot">
            <v-layout column align-center>
                <v-layout column align-start>
                    <div class="label">{{$f.tc('currentBot')}}</div>
                    <v-layout>
                        <div style="width: 250px">
                            <v-text-field
                                disabled hide-details
                                v-model="currentBotName"
                                class="input-custom"
                            ></v-text-field>
                        </div>
                        <div class="btn-custom btn-checkout" @click="goToScenario(campaign.bot.id)">
                            <img src="/img/checkout-blue.svg" style="transform: scale(0.95); margin-right: 6px"/>
                            Bot
                        </div>
                        <div class="btn-custom btn-checkout" @click="goToNLP(campaign.bot.id)">
                            <img src="/img/checkout-blue.svg" style="transform: scale(0.95); margin-right: 6px"/>
                            NLP
                        </div>
                    </v-layout>
                </v-layout>
                <v-layout column align-start style="margin-top: 12px">
                    <div class="label">{{isAdmin() ? $f.tc('bot') : $f.tc('template')}}</div>
                    <v-form v-model="formValid" ref="form" @submit="submit">
                        <v-layout>
                            <div style="width: 250px">
                                <v-autocomplete
                                    hide-details
                                    v-model="bot"
                                    :items="botList"
                                    :rules="formRules.required"
                                    class="input-custom"
                                ></v-autocomplete>
                            </div>
                            <div class="btn-custom btn-checkout" @click="goToScenario(bot)">
                                <img src="/img/checkout-blue.svg" style="transform: scale(0.95); margin-right: 6px"/>
                                Bot
                            </div>
                            <div class="btn-custom btn-checkout" @click="goToNLP(bot)">
                                <img src="/img/checkout-blue.svg" style="transform: scale(0.95); margin-right: 6px"/>
                                NLP
                            </div>
                        </v-layout>
                    </v-form>
                </v-layout>
            </v-layout>
        </div>
        <div class="step-actions">
            <div v-if="canGoBack" @click="goBack" class="btn-custom btn-back" dark>
                {{ backTitle || $f.tc('back') }}
            </div>
            <div @click="submit()" class="btn-custom">
                {{ nextTitle || $f.tc('next') }}
            </div>
            <div v-if="isEdit" @click="submit()" class="btn-custom">
                {{ $f.tc('save') }}
            </div>
        </div>
    </div>
</template>

<script>
import FormMixin from '@/modules/fptai/mixins/FormMixin'
import RoleMixin from '@/modules/fptai/mixins/RoleMixin'
import {mapState} from 'vuex'
import ScenarioService from "@/services/scenario.service";

export default {
    name: 'NewCampaignStep2',
    mixins: [FormMixin, RoleMixin],
    props: {
        next: Function,
        nextTitle: String,
        back: Function,
        canGoBack: Boolean,
        backTitle: String
    },
    data() {
        return {
            scenarioList: [],
            botList: [],
            bot: '',
            currentBotName: ''
        }
    },
    mounted() {
        this.getBotList()
    },
    computed: {
        ...mapState({
            campaign: state => state.campaign.campaign,
            isEdit: state => state.campaign.isEdit
        })
    },
    methods: {
        getBotList() {
            this.$appService.showLoading()
            ScenarioService.search({page: 1, page_size: 1000}).then(
                result => {
                    this.scenarioList = result.data.data
                    this.botList = this.scenarioList.map(item => ({text: item.name, value: item.id}))
                },
                this.$appService.handleRequestError(this.$t('actionFailed', {
                    action: this.$t('load'),
                    item: this.$t('nlp')
                }))
            ).finally(this.$appService.hideLoading)
        },
        submitValidForm() {
            this.$appService.showLoading()
            this.$store.dispatch(this.$actionTypes.campaign.UPDATE_CAMPAIGN, {
                campaign: this.campaign,
                model: {
                    bot: this.bot
                }
            }).then(
                () => {
                    if (typeof this.next === 'function') {
                        this.next()
                    }
                },
                this.$appService.handleRequestError(this.$t('actionFailed', {
                    action: this.$t('update'),
                    item: this.$t('campaign')
                }))
            ).finally(this.$appService.hideLoading)
        },
        goBack() {
            if (typeof this.back === 'function') {
                this.back()
            }
        },
        goToScenario(scenarioId) {
            window.open(this.$router.resolve(`/scenarios/${scenarioId}`).href)
        },
        goToNLP(scenarioId) {
            let bot = this.scenarioList.find(scenario => scenario.id === scenarioId)
            if (bot) {
                let botHost = process.env.VUE_APP_BOT_HOST || 'https://bot.fpt.ai'
                window.open(`${botHost}/bot/${bot.nlp.code}`)
            } else {
                this.$appService.toastError('You don not have permission to access this bot')
            }
        }
    },
    watch: {
        campaign: {
            immediate: true,
            handler: function () {
                if (this.campaign && this.campaign.bot) {
                    this.bot = this.campaign.bot.id
                    this.currentBotName = this.campaign.bot.name
                } else {
                    this.bot = ''
                    this.currentBotName = ''
                }
            }
        }
    }
}
</script>
<style scoped lang="scss">
.select-bot {
    display: block;
    margin: 0 auto;
    width: 100%;
    padding: 20px 0;
    max-width: 500px;
}


.input-custom {
    ::v-deep {
        .v-input__slot {
            height: 32px;
            background: #FFFFFF;
            border-radius: 5px;
            border: 1px solid #D9D9D9;
            outline: none;
            font-size: 14px;
            padding: 6px 12px;
            margin: 0;
            display: flex;
            align-items: center;

            &:before, &:after {
                border: none !important;
            }
        }

        .v-label {
            background: #FFFFFF !important;
            padding: 0 6px;

            &:not(.v-label--active) {
                font-size: 14px !important;
                padding-left: 0 !important;
            }
        }
    }
}

.label {
    font-family: "open sans semi";
    margin-bottom: 6px;
    font-size: 13px;
}

.step-actions {
    .btn-custom {
        margin-left: 8px;

        &:first-child {
            margin-left: 0 !important;
        }
    }
}

.btn-checkout {
    background: #FFFFFF;
    border: 1px solid #0052CC;
    color: #0052cc;
    margin-left: 8px;
    &:hover {
        background: #d9e5f7;
    }
}

::v-deep {
    .v-text-field {
        padding-top: 0 !important;
        margin-top: 0 !important;
    }
}

@media screen and (min-width: 600px) {
    .select-bot {
        padding: 48px 0 52px;
    }
}
</style>
